import { z } from "zod";

export const ContactUsSchema = z.object({
  name: z.string().min(2).max(50),
  email: z.string().email(),
  mobNumber: z.string().regex(/^\+?\d{10,14}$/),
});

export type UserInfoType = {
  name: {
    value: string;
    hasError: boolean;
    errorMsg: string;
  };
  email: {
    value: string;
    hasError: boolean;
    errorMsg: string;
  };
  mobNumber: {
    value: string;
    hasError: boolean;
    errorMsg: string;
  };
};

export const getInitialState = () => {
  return {
    name: {
      value: "",
      hasError: false,
      errorMsg: "Please enter your Name [min 2 character(s)]",
    },
    email: {
      value: "",
      hasError: false,
      errorMsg: "Please enter valid Email",
    },
    mobNumber: {
      value: "",
      hasError: false,
      errorMsg: "Please enter valid Mobile Number",
    },
  };
};
